import { useFormContext } from "react-hook-form";
import { ErrorMessages } from "../../../../components/errorMessages/errorMessages";

export const InputSelect = ({
  label = "label",
  name = "Name",
  required = true,
  options = [],
  placeholder = "",
}) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const selectedValue = watch(name);

  return (
    <div className="form-field mt-4">
      <label htmlFor={name} className="block text-base text-gray-400">
        {label}
      </label>
      <select
        id={name}
        {...register(name, {
          required: {
            value: required,
            message: `${label} is required`,
          },
        })}
        className={`bg-gray-50 border border-gray-300 text-md h-10 rounded-md form-select appearance-none bg-no-repeat px-3
          ${selectedValue ? "text-gray-900" : "text-gray-400"}`}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <ErrorMessages errors={errors?.[name]?.message} />
    </div>
  );
};
